import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
} from "@mui/material";
import MaterialInput from "../../../components/MaterialInput";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialButton from "../../../components/MaterialButton";
import { complaintStatus, GetComplaintById } from "./data";
import BASEURL from "../../../pages/Utils/Baseurl";
import request from "graphql-request";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";

const UpdateComplaintStatusDialog = ({ onClose, onSubmit, Id, disabled }) => {
  const [formData, setFormData] = useState({
    status: "",
    resolutionDescription: "",
    resolutionDate: "",
    actionsTaken: "",
    customerSatisfaction: "",
    closedRemarks: "",
  });

  useEffect(() => {
    if (Id) fetchData(Id);
  }, [Id]);

  //fetch api call
  const fetchData = async (Id) => {
    try {
      const response = await request(BASEURL, GetComplaintById, {
        complaintId: Id,
      });
      const value = response?.complaintById.data;
      if (value) {
        setFormData({
          status:
            {
              value: capitalizeFirstLetter(value.status),
              label: capitalizeFirstLetter(value.status),
            } || "",
          resolutionDescription: value.resolutionDescription || "",
          resolutionDate: value.resolutionDate || "",
          actionsTaken: value.actionsTaken || "",
          customerSatisfaction: value.customerSatisfaction || "",
          closedRemarks: value.closedRemarks || "",
        });
      }
    } catch (error) {
      console.error("Error fetching complaint data:", error);
    }
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  //onchange fields
  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  //submit function
  const handleSubmit = async () => {
    const {
      status,
      resolutionDescription,
      resolutionDate,
      actionsTaken,
      customerSatisfaction,
      closedRemarks,
    } = formData;

    if (
      !status ||
      !resolutionDescription ||
      !resolutionDate ||
      !actionsTaken ||
      !customerSatisfaction ||
      (status === "Closed" && !closedRemarks)
    ) {
      alert("All fields are required!");
      return;
    }

    await onSubmit(Id, formData);
    onClose(); // Close the dialog after submission
  };

  return (
    <Dialog open fullWidth maxWidth="sm" p={3}>
      <DialogTitle>Update Complaint Status</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Status <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <FormControl fullWidth>
              <MaterialSelect
                name="status"
                value={formData.status}
                customStyles={{ borderColor: "blue" }} // Example custom styles
                options={complaintStatus?.map((item) => ({
                  value: item,
                  label: item,
                }))}
                onChange={(selectedOption) =>
                  handleChange("status", selectedOption)
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Resolution Description <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              fullWidth
              margin="normal"
              placeholder="Resolution Description"
              multiline
              rows={3}
              value={formData.resolutionDescription}
              onChange={(e) =>
                handleChange("resolutionDescription", e.target.value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Date of Resolution <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              fullWidth
              margin="normal"
              placeholder="Date of Resolution"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={formData.resolutionDate}
              onChange={(e) => handleChange("resolutionDate", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Actions Taken <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              fullWidth
              margin="normal"
              placeholder="Actions Taken"
              multiline
              rows={3}
              value={formData.actionsTaken}
              onChange={(e) => handleChange("actionsTaken", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Customer Feedback <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              fullWidth
              margin="normal"
              placeholder="Customer Feedback"
              multiline
              rows={3}
              value={formData.customerSatisfaction}
              onChange={(e) =>
                handleChange("customerSatisfaction", e.target.value)
              }
            />
          </Grid>

          {formData.status.value === "Closed" && (
            <Grid item xs={12} sm={6}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Closed Remarks <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                fullWidth
                margin="normal"
                placeholder="Closed Remarks"
                multiline
                rows={3}
                value={formData.closedRemarks}
                onChange={(e) => handleChange("closedRemarks", e.target.value)}
              />
            </Grid>
          )}
          
        </Grid>
      </DialogContent>

      <DialogActions>
        <MaterialButton onClick={onClose} variant="gradient" color="dark">
          Cancel
        </MaterialButton>
        <MaterialButton
          onClick={handleSubmit}
          variant="gradient"
          color="dark"
          disabled={disabled}
        >
          Submit
        </MaterialButton>
      </DialogActions>

    </Dialog>
  );
};

export default UpdateComplaintStatusDialog;
